import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { forbiddenEmailValidator } from '../em.validator';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.sass']
})
export class DetailsComponent implements OnInit {
  public ID;
  detailsMessageForm: FormGroup
  detailsReportForm: FormGroup

  singlePost: {}
  lat: number
  long: number
  savedMessage = {}
  imgIndex = 0
  contactVal = true
  reportVal = false
  submitted = ""

  @ViewChild('contactB', {read: ElementRef}) contactB;
  @ViewChild('reportB', {read: ElementRef}) reportB;

  constructor(private activatedRoute: ActivatedRoute, private apiService: ApiService, private sanitizer: DomSanitizer, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.ID = this.activatedRoute.snapshot.params.id;
    this.apiService.getSinglePost(this.ID).subscribe(data1 => {
      this.apiService.getLocation(data1['address'], data1['city'], data1['state']).subscribe((data2) => {
        if (data2["items"].length !== 0) {
          this.lat = data2["items"][0]["position"]["lat"]
          this.long = data2["items"][0]["position"]["lng"]
        }
      })
      this.singlePost = data1
      this.singlePost['details'] = this.sanitizer.bypassSecurityTrustHtml(data1['details'])
    })

    this.detailsMessageForm = new FormGroup({
      'from_shopper': new FormControl('', [Validators.required]),
      'title': new FormControl('', [Validators.required]),
      'message': new FormControl('', [Validators.required]),
      'email': new FormControl(null, [Validators.required, forbiddenEmailValidator]),
    });

    this.detailsReportForm = new FormGroup({
      'from_shopper': new FormControl('', [Validators.required]),
      'title': new FormControl('', [Validators.required]),
      'message': new FormControl('', [Validators.required]),
      'email': new FormControl(null, [Validators.required, forbiddenEmailValidator]),
    });
  }

  back() {
    window.history.back();
  }

  swipeRight() {
    if (this.imgIndex === this.singlePost['gallery'].length - 1) {
      this.imgIndex = 0
    }

    else {
      this.imgIndex++
    }
  }

  swipeLeft() {
    if (this.imgIndex === 0) {
      this.imgIndex = this.singlePost['gallery'].length - 1
    }

    else {
      this.imgIndex--
    }
  }

  contactButton(val, val2) {
    if (!val) {
      this.renderer.removeClass(this.contactB.nativeElement,'deactivated')
      this.renderer.addClass(this.reportB.nativeElement,'deactivated')
      this.reportVal = false
      this.contactVal = true
      this.submitted = ''
    }
  }

  reportButton(val, val2) {
    if (!val2) {
      this.renderer.addClass(this.contactB.nativeElement,'deactivated')
      this.renderer.removeClass(this.reportB.nativeElement,'deactivated')
      this.reportVal = true
      this.contactVal = false
      this.submitted = ''
    }
  }

  submitMessage(val, val2) {
    val.preventDefault()
    this.submitted = 'loading'

    this.savedMessage['admin'] = ["f6006a3ac4e9", "excessmaterial.official@gmail.com"]
    this.savedMessage['to_seller'] = this.singlePost['user_id']
    this.savedMessage['from_shopper'] = this.detailsMessageForm.get('from_shopper').value
    this.savedMessage['title'] = this.detailsMessageForm.get('title').value
    this.savedMessage['message'] = this.detailsMessageForm.get('message').value
    this.savedMessage['email'] = this.detailsMessageForm.get('email').value
    this.savedMessage['selleremail'] = val2['email']
    this.savedMessage['report'] = false
    this.savedMessage['post_id'] = val2['id']
    this.savedMessage['tags'] = `${this.singlePost['user_id']}, ${this.detailsMessageForm.get('from_shopper').value}, ${this.detailsMessageForm.get('title').value}, ${this.detailsMessageForm.get('message').value}, ${this.detailsMessageForm.get('email').value}, ${this.savedMessage['selleremail']}, ${String(this.savedMessage['report'])}, ${String(this.savedMessage['post_id'])}`
    this.apiService.postMessage(this.savedMessage).subscribe(data => {
      this.submitted = 'submitted'
    })
  }

  submitReport(val, val2) {
    val.preventDefault()
    this.submitted = 'loading'

    this.savedMessage['admin'] = ["f6006a3ac4e9", "excessmaterial.official@gmail.com"]
    this.savedMessage['to_seller'] = this.singlePost['user_id']
    this.savedMessage['from_shopper'] = this.detailsReportForm.get('from_shopper').value
    this.savedMessage['title'] = this.detailsReportForm.get('title').value
    this.savedMessage['message'] = this.detailsReportForm.get('message').value
    this.savedMessage['email'] = this.detailsReportForm.get('email').value
    this.savedMessage['selleremail'] = val2['email']
    this.savedMessage['report'] = true
    this.savedMessage['post_id'] = val2['id']
    this.savedMessage['tags'] = `${this.singlePost['user_id']}, ${this.detailsReportForm.get('from_shopper').value}, ${this.detailsReportForm.get('title').value}, ${this.detailsReportForm.get('message').value}, ${this.detailsReportForm.get('email').value}, ${this.savedMessage['selleremail']}, ${String(this.savedMessage['report'])}, ${String(this.savedMessage['post_id'])}`
    this.apiService.postMessage(this.savedMessage).subscribe(data => {
      this.submitted = 'submitted'
    })
  }

}
